import Popup from 'reactjs-popup';
import "./popup.css"
import 'reactjs-popup/dist/index.css';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    }
  }));

const  SurveyPopup = ({dataObj, triggerElement}) => {


    const classes = useStyles();

    const getlink = () => {
        if(dataObj.survey_link!=null){
            if(dataObj.survey_link.substring(0,4) == "http") {
                return dataObj.survey_link;
            } else {
                return "https://" + dataObj.survey_link;
            }
        }
    }
    return (
        <Popup
            trigger={triggerElement()}
            position="right center" modal nested className="survey-popup">
            {close => {
                return (
                    <div className="#survey-modal">

                        <div id="modal-header-container">
                            <h3 id='modal-header'>{dataObj.survey_name}</h3>

                            <button className="close" onClick={() => {close()}}>
                                &times;
                            </button>
                        </div>

                        <div id="modal-table">

                            <div className={classes.root} id='survey-info-grid'>

                                <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                        <div id="description">
                                            <p>{dataObj.survey_description}</p>
                                        </div>
                                    </Grid>

                                    <Grid item xs={4}>
                                        {cellFactory("Survey association", dataObj.survey_association)}
                                    </Grid>
                                    <Grid item xs={4}>
                                        {cellFactory("Survey platform", dataObj.survey_platform)}
                                    </Grid>
      ;                             <Grid item xs={4}>
                                        {cellFactory("Survey language", dataObj.survey_language)}
                                    </Grid>
                                    <Grid item xs={4}>
                                        {cellFactory("Target group", dataObj.target_group)}
                                    </Grid>
                                    <Grid item xs={4}>
                                        {cellFactory("Deadline", dataObj.deadline)}
                                    </Grid>
                                </Grid>
                            </div>
                        </div>

                        <div className="actions">
                            <button id="fill-survey-button"><a href={getlink()} class="survey-link">Fill in the survey</a></button>
                        </div>
                    </div>
                )
            }}
        </Popup>
    )
}

const cellFactory = (attrName, attrVal) => {
    return (
        <div className='cell-container'>
            <span className='cell-name'>{attrName}</span>
            <span className='cell-data'>{attrVal}</span>
        </div>
    )
}

export default SurveyPopup;